<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import AdvancedDoughnutChart from "@/components/app/charts/AdvancedDoughnutChart.vue";

const props = defineProps({
  radius: {
    type: Number,
    default: 150,
  },
  sourceData: {
    type: Object,
    required: true,
  },
  chartName: String,
  legendPositionBottom: {
    type: Boolean,
    default: false,
  },
});

const chart = ref({
  labels: null,
  data: null,
  backgroundColors: null,
});

const options = ref({
  responsive: false,
  maintainAspectRatio: true,
  animation: {
    duration: 2000,
  },
});

const chartStyle = computed(() => {
  return {
    width: `${props.radius}px`,
    height: `${props.radius}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});

watch(
  () => props.sourceData,
  () => {
    console.log("ChartBuildingFunctions watch sourceData", props.sourceData);
    let backgroundColors = [];
    let values = [];

    Object.values(props.sourceData).forEach((data) => {
      backgroundColors.push(data.color ? data.color : "#CCCCCC");
      values.push(data.val);
    });

    chart.value.backgroundColors = backgroundColors;
    chart.value.labels = Object.keys(props.sourceData);
    chart.value.data = values;
  },
  { immediate: true, deep: true }
);
</script>

<template>
  <div class="vue-chart building-functions building-measures">
    <AdvancedDoughnutChart :legend-position-bottom="legendPositionBottom" :data-set="chart" :options="options" :style="chartStyle" :chartName="chartName"></AdvancedDoughnutChart>
  </div>
</template>
